import gql from 'graphql-tag'
import AUDIENCE_QUESTION_LOGIC from '../fragments/audienceQuestionLogic'
import AUDIENCE_QUESTION_LOGIC_MEMBER from '../fragments/audienceQuestionLogicMember'

// Raw `gql` and the IR-notification directive follow the other audience mutations.
export const SET_AUDIENCE_QUESTION_LOGIC_V2 = gql`
  mutation setAudienceQuestionLogicV2(
    $input: SetAudienceQuestionLogicV2Input!
  ) {
    recordAudienceChangedForIRSNotification @client(always: true)
    setAudienceQuestionLogicV2(input: $input) {
      surveyId
      members {
        ...AudienceQuestionLogicMember
      }
    }
  }
  ${AUDIENCE_QUESTION_LOGIC_MEMBER}
  ${AUDIENCE_QUESTION_LOGIC}
`
